import React from 'react'
import './header.css'
import CTA from './CTA'
import HeaderSocials from './HeaderSocials'
import ME from '../../assets/logowebsiteka.png'

const Header = () => {
  return (
    <header>
        <div className="container header__container">
            <h5>Welcome to the World of</h5>
            <h1 className='gradient-text'>At A Glance!</h1>
            <h5 className="text-light">Unlock the Wonders of Technology!</h5>
            <CTA/>
            <HeaderSocials/>
            <div className="me">
                <img className="rotate-it" src={ME} alt="me" />
            </div>

            <a href="#contact" className="scroll__down">Scroll Down</a>
        </div>
    </header>
  )
}

export default Header